<template>
  <div>
    <el-form label-width="80px">
      <el-form-item label="Pest type" >
        <el-select v-model="selectedPestType">
          <el-option v-for="item in lures"
                     :key="item.pestTypeId"
                     :label="item.name"
                     :value="item.pestTypeId" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="selectedPestType !== ''" label="Lure">
        <el-select v-model="orgLure.lureId">
          <el-option v-for="item in availableLures"
                     :key="item.id"
                     :label="`${item.name} (${item.productCode})`"
                     :value="item.id" />
        </el-select>
      </el-form-item>
      <div v-if="orgLure.lureId && availableLures.some(lure => lure.id === this.orgLure.lureId)">
        <el-form-item label="Quantity">
          <el-input-number v-model="orgLure.quantity"
                           size="small"
                           step-strictly
                           :min="0" />
        </el-form-item>
        <el-form-item label="Due date">
          <el-date-picker v-model="orgLure.lureDueDate"
                          class="d-block w-100"
                          value-format="yyyy-MM-dd"
                          format="dd/MM/yyyy"
                          type="date"
                          placeholder="Set due date" />
        </el-form-item>
        <el-form-item label="Is trial?">
          <el-checkbox v-model="orgLure.isTrial" />
        </el-form-item>
        <el-form-item label="Comments">
          <el-input type="textarea"
                    :rows="2"
                    placeholder="Type your comments here"
                    v-model="orgLure.comments" />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { Checkbox, DatePicker, Form, FormItem, Input, InputNumber, Option, Select } from 'element-ui';
import { OrganisationLureModel } from '@/models/organisation/organisationLure';

export default {
  name: 'form-new-org-lure',
  props: {
    lures: {
      type: Array,
      default: [],
      required: true
    },
    orgLure: {
      type: OrganisationLureModel,
      required: true
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [DatePicker.name]: DatePicker,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      selectedPestType: '',
    }
  },
  computed: {
    availableLures: {
      get() {
        const selectedItem = this.lures.find(item => item.pestTypeId === this.selectedPestType);
        if (selectedItem) {
          return selectedItem.lures;
        }
        return [];
      },
    }
  },
  watch: {
    selectedPestType() {
      if (!this.availableLures.some(lure => lure.id === this.orgLure.lureId)) {
        this.orgLure.lureId = ''
      }
    }
  }

};
</script>